import request from "@/util/request";
export function GetDItemSelect(data) {
  return request({
    url: "/api/BaseData/GetDItemSelect",
    method: "get",
    params: data
  });
}
export function GetStationTree(data) {
  return request({
    url: "/api/BaseData/GetStationTree",
    method: "get",
    params: data
  });
}
export function GetGroupSelect(data) {
  return request({
    url: "/api/BaseData/GetGroupSelect",
    method: "get",
    params: data
  });
}
export function GetGroupTree(data) {
  return request({
    url: "/api/BaseData/GetGroupTree",
    method: "get",
    params: data
  });
}
export function GetDItemTree(data) {
  return request({
    url: "/api/BaseData/GetDItemTree",
    method: "get",
    params: data
  });
}
export function GetStationSelector(data) {
  return request({
    url: "/api/BaseData/GetStationSelector",
    method: "get",
    params: data
  });
}
export function GetParentLevelStationTree(data) {
  return request({
    url: "/api/BaseData/GetParentLevelStationTree",
    method: "get",
    params: data
  });
}
export function GetStationSelect(data) {
  return request({
    url: "/api/BaseData/GetStationSelect",
    method: "get",
    params: data
  });
}
export function GetPageDItemSelect(data) {
  return request({
    url: "/api/BaseData/GetPageDItemSelect",
    method: "get",
    params: data
  });
}
export function GetTrafficCategorySelect(data) {
  return request({
    url: "/api/BaseData/GetTrafficCategorySelect",
    method: "get",
    params: data
  });
}
export function GetDeviceSelect(data) {
  return request({
    url: "/api/BaseData/GetDeviceSelect",
    method: "get",
    params: data
  });
}

// [下拉]获取单位
export function GetUnitSelect(data) {
  return request({
    url: '/api/BaseData/GetUnitSelect',
    method: 'GET',
    params: data
  })
}

// [下拉]获取报警类型
export function GetAlarmRuleSelect(data) {
  return request({
    url: '/api/BaseData/GetAlarmRuleSelect',
    method: 'GET',
    params: data
  })
}
// [下拉]获取报警状态
export function GetAlarmStateSelect(data) {
  return request({
    url: '/api/BaseData/GetAlarmStateSelect',
    method: 'GET',
    params: data
  })
}

// [下拉]获取站点标签
export function GetFunctionCategorySelect(data) {
  return request({
    url: '/api/BaseData/GetFunctionCategorySelect',
    method: 'GET',
    params: data
  })
}

// [下拉]获取消息发送器
export function GetMessageSenderSelect(data) {
  return request({
    url: '/api/BaseData/GetMessageSenderSelect',
    method: 'GET',
    params: data
  })
}

// [下拉]获取报警级别
export function GetAlarmLevelSelect(data) {
  return request({
    url: '/api/BaseData/GetAlarmLevelSelect',
    method: 'GET',
    params: data
  })
}

// [下拉]获取报警推送时间
export function GetAlarmPushTimeRangeSelect(data) {
  return request({
    url: '/api/BaseData/GetAlarmPushTimeRangeSelect',
    method: 'GET',
    params: data
  })
}

export function GetStationDeviceSelect(data) {
  return request({
    url: '/api/BaseData/GetStationDeviceSelect',
    method: 'GET',
    params: data
  })
}

export function GetControlCommandStateSelect(data) {
  return request({
    url: '/api/BaseData/GetControlCommandStateSelect',
    method: 'GET',
    params: data
  })
}

export function GetStationStandard(data) {
  return request({
    url: '/api/BaseData/GetStationStandard',
    method: 'GET',
    params: data
  })
}

export function GetFunctionAreaStandard(data) {
  return request({
    url: '/api/BaseData/GetFunctionAreaStandard',
    method: 'GET',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/baseData.js